var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-content"},[_c('ul',_vm._l((_vm.arr),function(pep,index){return _c('ToDoLi',{key:index,attrs:{"content":pep},on:{"listenToChildEvent":_vm.showMsg}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }